import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Copyright from './Copyright';
import { ModalWidget } from '~/shared/ui/modals/modalWidget/ModalWidget';

export default function MainGrid({ children }: any) {
  const [open, setOpen] = React.useState(false);

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 12 }}>
          {children}
        </Grid>

      </Grid>
      <Copyright sx={{ my: 4 }} />
      <ModalWidget
        open={open}
        handleOpen={function (): void {
          throw new Error('Function not implemented.');
        }}
        handleClose={() => setOpen(!open)}
      />
    </Box>
  );
}
